import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';


import {Tabs3Level} from 'src/components/tabs-3-level';
import {ACCOUNT_TABS} from 'src/constants';
import {LICENSE_AND_FEATURES_SUB_TABS} from 'src/modules/profile/account/tabs/license-and-features/constants';

import {Tab} from '@pb/kit-component-tabs-v2';

import {REPORTS_SUB_TABS} from './constants';

type Props = {
    accountId: number,
    licenseId: number,
    activeSubTab: string,
};
export const ReportsTabs = ({accountId, licenseId, activeSubTab}: Props) => {
    const navigate = useNavigate();

    const setActiveTab = useCallback((tab: string) => {
        navigate(
            `/profile/account/${accountId}/` +
            `${ACCOUNT_TABS.LICENSE.name}/${licenseId}/${LICENSE_AND_FEATURES_SUB_TABS.REPORTS.name}/${tab}`,
        );
    }, [accountId, licenseId, navigate]);

    return (
        <Tabs3Level activeTab={activeSubTab} setActiveTab={setActiveTab}>
            <Tab
                value={REPORTS_SUB_TABS.USAGE_REPORT.name}
                {...REPORTS_SUB_TABS.USAGE_REPORT}
            />
            <Tab
                value={REPORTS_SUB_TABS.EXCEL_PLUGIN_USAGE_REPORT.name}
                {...REPORTS_SUB_TABS.EXCEL_PLUGIN_USAGE_REPORT}
            />
            <Tab
                value={REPORTS_SUB_TABS.PASSWORD_SHARING.name}
                {...REPORTS_SUB_TABS.PASSWORD_SHARING}
            />
            <Tab
                value={REPORTS_SUB_TABS.ASSOCIATED_BROWSERS.name}
                {...REPORTS_SUB_TABS.ASSOCIATED_BROWSERS}
            />
            <Tab
                value={REPORTS_SUB_TABS.USER_LIST.name}
                {...REPORTS_SUB_TABS.USER_LIST}
            />
        </Tabs3Level>
    );
};
